module.exports = __webpack_public_path__ + "static/media/background-login-b2b.d70696a2.svg";